<template>
	<div>
		<!-- <v-card-actions>			
			<v-spacer></v-spacer>	
			<v-btn color="warning" @click="downloadWithCSS">
				<v-icon>cloud_download</v-icon> PDF
			</v-btn>			
			<v-btn color="info" @click="exportTableToExcel('tblData', 'members-data')">
				<v-icon>description</v-icon> Excel
			</v-btn>
		</v-card-actions> -->

		<v-toolbar
		dark
		fixed
		app
		height="50"
		class="toolBar"
		>
		<v-spacer></v-spacer>

		<v-toolbar-items>
			<v-icon class="white--text" @click="downloadWithCSS('Monthly-Progress-Report')">cloud_download</v-icon>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<v-icon class="white--text" @click="printdiv">print</v-icon>
		</v-toolbar-items>
	</v-toolbar>

<!-- {{items}}
<br><br>
{{subItems}} -->
<v-container grid-list-md :class="{opacityC:isTrue}">
      <v-layout wrap>
        <v-flex xs10 offset-xs1>
          <div style="background:#FFF; padding:20px;">
			<div ref="content" id="print_div">				
				<table class="reportTbl" width="100%" id="tblData" >
					<tbody>
						<tr class="txtCenter borderNo">
							<td colspan="8" style="font-weight:bold;">Investment Promotion &amp; Financing Facility I (IPFF I) Project </td>
						</tr>
						<tr class="txtCenter borderNo" style="font-weight:bold;">
							<td colspan="8">IDA Credit No. 6004(Portion A)...</td>
						</tr>
						<tr class="txtCenter borderNo">
							<td colspan="8">1E, Project Cash Forecast Statement</td>
						</tr>
						<tr class="txtCenter borderNo">
							<td colspan="8">For the reporting quater Januar May-</td>
						</tr>
						<tr class="borderNo">
							<td colspan="6">&nbsp;&nbsp;</td>
							<td colspan="2" class="textRight" style="padding:0px;">Amount USD</td>
						</tr>
						<tr class="tb-td">
							<td rowspan="3">Category No</td>
							<td rowspan="3">Category Description</td>
							<td colspan="2">Cash requirement for January May - 2020</td>
							<td colspan="2">Cash requirement for August-2020 November-</td>
							<td colspan="2">Eligible total requirment for six months ending November-2020</td>
						</tr>
						<tr class="tb-td">
							<td>Credit A</td>
							<td>Credit B</td>
							<td>Credit A</td>
							<td>Credit B</td>
							<td>Credit A</td>
							<td>Credit B</td>
						</tr>
						<tr class="tb-td">
							<td colspan="2">Q1</td>
							<td colspan="2">Q2</td>
							<td colspan="2">Q3</td>
						</tr>
						<tr>
							<td class="textCenter">1</td>
							<td>Facility Loans for In ....</td>
							<td class="textRight">311231</td>
							<td></td>
							<td class="textRight">123123123</td>
							<td></td>
							<td class="textRight">34534535</td>
							<td></td>
						</tr>
						<tr>
							<td class="textCenter">2</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr class="borderNo">
							<td colspan="8">&nbsp;</td>
						</tr>
						<tr class="borderNo">
							<td colspan="8">&nbsp;</td>
						</tr>
						<tr class="tb-td">
							<td colspan="5">Particulers</td>
							<td colspan="3">Amound in USD</td>
						</tr>
						<tr>
							<td colspan="5">dfgdfgdfg</td>
							<td colspan="3" class="textRight">4000</td>
						</tr>
						<tr>
							<td colspan="5" class="textBold">Request amount to be advanced to DA</td>
							<td colspan="3" class="textRight">4000</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
        </v-flex>
      </v-layout>
    </v-container> 

		
	</div>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas"
const commonService = require("../../../services/common.service");
export default {
	props:['paramVal'],
	data: () => ({
		
		items:{},
		subItems:[],
		isTrue:false,
		
	}),

	created(){		
		//console.log('created');
		this.getData();
	},

	watch: {
        paramVal() {
        	this.getData();
        }
    },

	methods: {

		getData(){

			let root = this;
			let formSchema = '';
			let p = this.paramVal;
			
			if(typeof p == "undefined")
			{
				this.isTrue = false;
				formSchema = JSON.parse(sessionStorage.getItem('report'));
			}
			else
			{
				this.isTrue = true;
				formSchema = this.paramVal;
			}
			
			/*let formSchema = {
				'project_id': 1,
				'report_type': 1,
			}*/

			commonService.dataByMulParameters(formSchema, "monthly-impli-report").then(res => {
				//console.log('res', res);
				if(res)
				{
					if(res.mainQueryData.length>0)
					{
						this.items = res.mainQueryData[0]
					}

					if(res.querySub.length>0)
					{
						this.subItems = res.querySub
					}

					/*if(formSchema.report_type == 1)
					{
						this.downloadWithCSS('Monthly-Progress-Report');
					}
					else
						*/

					if(formSchema.report_type == 0)
					{	
						setTimeout(function(){							
							root.exportTableToExcel('tblData', 'Monthly-Progress-Report');
						},1000);							
					}					
				}

			});
		},

		downloadWithCSS(filename='') {			
			const doc = new jsPDF({
				orientation: "a4",
		        // unit: "pt",
		        format: [740, 1000]
		    });
			/** WITH CSS */
			var canvasElement = document.createElement('canvas');
			html2canvas(this.$refs.content, { canvas: canvasElement }).then(function (canvas) {
				const img = canvas.toDataURL("image/jpeg", 0.8);
				
				//doc.addImage(img,'JPEG',0,20);
				doc.addImage(img,'JPEG',10,10);

				filename = filename?filename+'.pdf':'pdf-file.pdf';

				doc.save(filename);
				//window.open(filename)
			});
		},

		exportTableToExcel: function(tableID, filename = ''){
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename?filename+'.xls':'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if(navigator.msSaveOrOpenBlob){
				var blob = new Blob(['\ufeff', tableHTML], {
					type: dataType
				});
				navigator.msSaveOrOpenBlob( blob, filename);
			}else{
			// Create a link to the file
			downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

			// Setting the file name
			downloadLink.download = filename;

			//triggering the function
			downloadLink.click();
		}		
	},

checkDateFormate(){

},

	printdiv: function () {
                this.printContentStatus = true;
                const divToPrint = document.getElementById("print_div");
                this.printContentStatus = false;
                const newWin = window.open("", "Print-Window");
                newWin.document.open();
                newWin.document.write(
                    '<style type="text/css">'+
                    'table.reportTbl{width:100%;border-collapse:collapse}.reportTbl td{border:1px solid #ccc;padding:6px}.reportTbl tr td{text-align:left;line-height:15px}.txtRight{text-align:right!important}.reportTbl tr.txtCenter td{text-align:center}.reportTbl tr.tb-td td{font-weight:700;text-align:center;}td.textCenter{text-align:center!important}td.textRight{text-align:right !important}.reportTbl tr.borderNo td{border:none !important;}'+
                    "</style>"
                );
                newWin.document.write(
                    '<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
                    divToPrint.innerHTML +
                    "</body></html>"
                );

                newWin.document.close();
                setTimeout(function () {
                    newWin.close();
                }, 10);
            },

}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table.reportTbl{
	width:100%;
	border-collapse: collapse;
}
.reportTbl td{
	border:1px solid #CCC;
	padding: 6px;
}
.reportTbl tr td{	
	text-align:left;
	line-height: 15px;
}
.txtRight{	
	text-align:right !important;
}
.reportTbl tr.txtCenter td{	
	text-align:center;
}
.reportTbl tr.borderNo td{	
	border:none !important;
}
.reportTbl tr.tb-td td{
	font-weight: bold;
	text-align:center;
}
td.textCenter{
	text-align: center !important;
}
td.textBold{
	font-weight:bold;
}
td.textRight{
	text-align: right !important;
}
.subTable tr td{
	/*text-align: center !important;*/
}
</style>



// WEBPACK FOOTER //
// src/components/reportGenerate/pdf/projectCashForStatementReport.vue